import { Observable } from 'rxjs';

export abstract class BriefLocationInfo implements BriefLocationInfoInterface {
  abstract locationInfo$: Observable<BriefLocationInfoModel>;
}

export interface BriefLocationInfoInterface {
  locationInfo$: Observable<BriefLocationInfoModel>;
}

export interface BriefLocationInfoModel {
  compartmentId: number;
  dockId: number;
}
